import toString from 'lodash/toString';

export const getScreenMessageId = (screen: number) => screen < 9 ? `0${screen + 1}` : toString(screen + 1);
